export default __webpack_public_path__ + "static/media/pawprint_logo.a8cac01c.png";